// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1532":"43a54519","2076":"c744838d","2846":"dfdac76d","3357":"e54425cd","6952":"ec707178","7170":"c649d4f0","7456":"cf1aafa5","8158":"e3cb6415","9567":"b85f925d","9972":"8abce4cf"}[chunkId] + ".chunk.css";
};